<ng-container [formGroup]="formGroup">
  <div class="row">
    <div class="col-auto align-self-center">
      <h4 class="mb-none">Residential History</h4>
    </div>
    <div class="col pl-none">
      <lds-button
        appearance="default"
        variation="link"
        iconBefore="add"
        (onClick)="add()">
        Add a Residence
      </lds-button>
    </div>
  </div>

  <div formArrayName="residences">
    <ng-container *ngIf="form.controls.length > 0; else tplNoItems">
      <ng-container *ngFor="let itemForm of form.controls; let i = index">
        <app-inline-item
          *ngIf="!deleted[i]"
          [form]="itemForm"
          [formGroupName]="i"
          [isExpandable]="true"
          [initiallyExpanded]="expandedIndex === i"
          (delete)="remove(i)">
          <inline-summary>
            <div class="row">
              <div class="col-9">
                {{
                  itemForm.controls.address.value
                    | agpSharedReadableAddress
                    | summary
                }}
              </div>
              <div class="col">
                {{ itemForm.controls.addressType.value | summary }}
              </div>
            </div>
          </inline-summary>
          <inline-content>
            <div class="row">
              <div class="col-12">
                <agp-shared-address
                  label="Address"
                  formControlName="address"
                  identifier="address"
                  [options]="addressOptions$ | async"
                  [isRequired]="
                    (schema.address.localAddress.streetName
                      | standardRequirement) ||
                    (schema.address.internationalAddress.addressLine1
                      | standardRequirement)
                  ">
                </agp-shared-address>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-select
                  formControlName="addressType"
                  name="addressType"
                  label="Address type"
                  [options]="schema.addressType.options | ldsSelectOption"
                  [isRequired]="schema.addressType | standardRequirement"
                  [validations]="{
                    required: 'Address type is required'
                  }">
                </lds-select>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-select
                  formControlName="residentialStatus"
                  name="residentialStatus"
                  label="Residential status"
                  [options]="schema.residentialStatus.options | ldsSelectOption"
                  [isRequired]="schema.residentialStatus | standardRequirement"
                  [validations]="{
                    required: 'Residential status is required'
                  }">
                </lds-select>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-date-input
                  formControlName="startDate"
                  name="startDate"
                  label="Start date"
                  [isRequired]="schema.startDate | standardRequirement"
                  [validations]="{
                    required: 'Start date is required',
                    date: 'Must be a valid date',
                    dateBefore: 'Must be a date in the past'
                  }">
                </lds-date-input>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-date-input
                  formControlName="endDate"
                  name="endDate"
                  label="End date"
                  [isRequired]="schema.endDate | standardRequirement"
                  [validations]="{
                    required: 'End date is required',
                    date: 'Must be a valid date',
                    dateGreaterThan: 'Must be after the start date',
                    dateBefore: 'Must be a date in the past'
                  }">
                </lds-date-input>
              </div>
            </div>
          </inline-content>
        </app-inline-item>
      </ng-container>
    </ng-container>
    <ng-template #tplNoItems>
      <p>None</p>
    </ng-template>
  </div>
  <lds-form-feedback
    *ngIf="isRequired && form.touched && form.invalid"
    [control]="form"
    [messages]="{
      required: 'At least one residence is required',
      minlength: 'At least one residence is required'
    }">
  </lds-form-feedback>
</ng-container>
